import { render, staticRenderFns } from "./EditExpense.vue?vue&type=template&id=3befb7d6&scoped=true&"
import script from "./EditExpense.vue?vue&type=script&lang=js&"
export * from "./EditExpense.vue?vue&type=script&lang=js&"
import style0 from "./EditExpense.vue?vue&type=style&index=0&id=3befb7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3befb7d6",
  null
  
)

export default component.exports